import { faQuestion } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Colors } from '@vetahealth/fishing-gear/colors'
import { isTruthy } from '@vetahealth/fishing-gear/lib/typeguards'
import { Badge, Button, Dropdown, Tooltip } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TrackingEvent, trackEvent } from '../lib/tracking'
import { useAppStore } from '../stores/app'
import { ModalName, useModalStore } from '../stores/modal'

enum MenuKeys {
  emailSupport = 'emailSupport',
}

export function Help(): React.ReactNode {
  const { t } = useTranslation()

  const [openModal] = useModalStore((state) => [state.openModal])
  const [markReleaseInfoAsRead] = useAppStore((state) => [state.markReleaseInfoAsRead])
  const [isMenuVisible, setIsMenuVisible] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const [releases] = useAppStore((state) => [state.releaseInfo])

  function handleVisibilityChange(visible: boolean): void {
    setIsMenuVisible(visible)
    if (visible) setShowTooltip(false)
  }

  function handleSelection({ key }: { key: string }): void {
    setIsMenuVisible(false)
    switch (key) {
      case MenuKeys.emailSupport:
        trackEvent(TrackingEvent.settingsMenuEmailSupportClicked)
        openModal(ModalName.emailSupport)
        return

      case releases.find((release) => release.id === key)?.id: {
        trackEvent(TrackingEvent.settingsMenuReleaseInfoClicked, { releaseId: key })
        const selectedRelease = releases.find((release) => release.id === key)
        if (selectedRelease && !selectedRelease.isRead) {
          markReleaseInfoAsRead(key)
        }
        openModal(ModalName.releaseInfo, { releaseId: key })
        return
      }
    }
  }

  const menuItems: any[] = [
    {
      type: 'group',
      key: 'help',
      label: t('menus.help.title'),
      children: [{ key: MenuKeys.emailSupport, label: t('menus.help.emailSupport') }],
    },
    releases.length > 0 && {
      type: 'group',
      key: 'whatsNew',
      label: t('menus.help.whatsNew'),
      children: releases.map((release) => ({
        key: release.id,
        label: release.title,
        icon: <Badge dot color={release.isRead ? Colors.gray200 : Colors.green500} />,
      })),
    },
  ].filter(isTruthy)

  return (
    <div>
      {/** biome-ignore lint/a11y/noStaticElementInteractions: <Only used for mouse over event> */}
      <div onMouseEnter={() => setShowTooltip(!isMenuVisible)} onMouseLeave={() => setShowTooltip(false)}>
        <Dropdown
          menu={{ items: menuItems, onClick: handleSelection }}
          trigger={['click']}
          placement="bottomLeft"
          onOpenChange={handleVisibilityChange}
        >
          <Tooltip title={t('menus.help.title')} open={showTooltip} placement="bottomLeft">
            <Badge dot={!releases.every((release) => release.isRead)} color={Colors.green500}>
              <Button
                icon={<FontAwesomeIcon icon={faQuestion} />}
                onClick={() => trackEvent(TrackingEvent.settingsMenuClicked)}
                shape="circle"
              />
            </Badge>
          </Tooltip>
        </Dropdown>
      </div>
    </div>
  )
}
